import { apiPaths } from '../../../service/apiPaths';
import ApiService from '../../../service/ApiService';
import { IAddEmployee } from './Employee.props';

export const addEmployee = async (data: IAddEmployee) => {
  return ApiService({
    method: "POST",
    endpoint: apiPaths.createEmployee,
    data,
  });
};

export const updateEmployee = async (id: string, data: IAddEmployee) => {
  return ApiService({
    method: "PUT",
    endpoint: `${apiPaths.updateEmployee}/${id}`,
    data,
  });
};

export const getEmployee = async (id: string) => {
    return ApiService({
        method: "PUT",
        endpoint: `${apiPaths.getEmployees}/${id}`,
      });
};

